import { clearSession, getSessionToken, tryRefreshToken } from './auth-client';

/**
 * API client cho ERP-AC backend.
 * Tự attach Bearer token từ session. Khi 401: thử refresh token trước;
 * refresh thất bại thì mới clear session + redirect /login.
 */
export async function apiFetch<T = unknown>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const token = getSessionToken();
  const headers = new Headers(init.headers);
  if (token) headers.set('Authorization', `Bearer ${token}`);
  if (!headers.has('Content-Type') && init.body && typeof init.body === 'string') {
    headers.set('Content-Type', 'application/json');
  }

  let res = await fetch(path, { ...init, headers });

  if (res.status === 401) {
    // Access token hết hạn — thử refresh trước khi đá user về /login
    const refreshed = await tryRefreshToken();
    if (refreshed) {
      const newToken = getSessionToken();
      if (newToken) {
        headers.set('Authorization', `Bearer ${newToken}`);
        res = await fetch(path, { ...init, headers });
      }
    }
    if (res.status === 401) {
      clearSession();
      window.location.assign('/login');
      throw new Error('Session expired');
    }
  }

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`API ${res.status} ${path}: ${text}`);
  }

  const contentType = res.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    return (await res.json()) as T;
  }
  return (await res.text()) as unknown as T;
}
